import { Radius } from '@sparemin/blockhead';
import React from 'react';
import { DEFAULT_SLIDE_ASSET_BORDER_RADIUS_VW } from 'utils/constants';
import { ViewportWidth } from 'utils/measurement';
import { useTemplateDispatch } from '../context/VideoTemplateDispatchContext';
import useMainMedia from '../useMainMedia';
import ControlToggle from './ControlToggle';

export interface VideoPodcastSettingsBorderRadiusToggleProps {}

const VideoPodcastSettingsBorderRadiusToggle: React.FC<VideoPodcastSettingsBorderRadiusToggleProps> = () => {
  const { asset, type } = useMainMedia();

  const dispatch = useTemplateDispatch();

  const handleBorderRadiusChange = React.useCallback(
    (isSelected: boolean): void => {
      dispatch({
        type: 'IMAGE_BORDER_RADIUS_CHANGE',
        payload: {
          id: asset?.id,
          borderRadius: isSelected
            ? new ViewportWidth(DEFAULT_SLIDE_ASSET_BORDER_RADIUS_VW)
            : undefined,
        },
      });
    },
    [asset, dispatch],
  );

  return (
    <ControlToggle
      icon={<Radius height={40} width={40} />}
      isActive={type === 'image' && !!asset?.borderRadius}
      label="Round corners"
      onChange={handleBorderRadiusChange}
    />
  );
};

export default VideoPodcastSettingsBorderRadiusToggle;
